<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="90%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="hidden-sm-and-down" v-bind="attrs" v-on="on" color="primary" dark
          :disabled="!plano.id || !plano.ativo" alt="Incluir Atividade"
          @click="abrirCadastro()" title="Incluir Atividade Extra">
          <v-icon>add</v-icon>Incluir
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">
              <v-layout wrap>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Ano" disabled :value="plano.ano"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Número" disabled :value="plano.numero"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Data Início" disabled :value="plano.dataInicio"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Data Fim" disabled :value="plano.dataFim"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field color="primary" label="Descrição do Plano" disabled :value="plano.descricao"></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider class="my-3"></v-divider>
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                  <date-picker-custom label="Data" :v-model="atividade.data" @date="onDataChange"
                    :error-messages="fieldErrors('atividade.data')"></date-picker-custom>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field color="primary" label="Dia Semana" disabled :value="diaSemana"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field v-model.number="atividade.qtdeHora" type="number" min="1" label="Qtde Horas"
                    :error-messages="fieldErrors('atividade.qtdeHora')"
                    @blur="$v.atividade.qtdeHora.$touch()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md5>
                  <v-text-field v-model="atividade.descricao" maxlength="50" label="Descrição"
                    :error-messages="fieldErrors('atividade.descricao')"
                    @blur="$v.atividade.descricao.$touch()"></v-text-field>
                </v-flex>
              </v-layout>
              <v-divider class="my-3"></v-divider>
              <h4>Participantes</h4>
              <div class="qh-atv-extra-funcs-scroll">
                <v-data-table :loading="loading" :headers="headers" :items="funcionarios" class="elevation-1" hide-actions>
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-checkbox v-model="props.item.participante" hide-details></v-checkbox>
                    </td>
                    <td>{{ props.item.numeroRegistro }}</td>
                    <td>{{ props.item.nome }}</td>
                    <td>{{ props.item.funcao }}</td>
                  </template>
                  <template slot="no-data">
                    Nenhum funcionário com previsão no plano.
                  </template>
                </v-data-table>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="confirmar" dark>{{ btnTitle }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhAtvExtraService from "@/service/qh/QhAtvExtraService";
import QhAtvExtra from "@/model/qh/QhAtvExtra";
import DatePickerCustom from "@/components/Custom/DatePickerCustom";
import { required, maxLength, integer, minValue } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import messageMixin from "@/mixins/message";
import EventBus from "@/utils/EventBus";

const DIAS_SEMANA = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

export default {
  name: "ModalCadastroQhAtvExtra",
  components: { DatePickerCustom },
  props: {
    plano: { type: Object, default: () => ({}) }
  },
  mixins: [validationMixin, messageMixin],
  validations: {
    atividade: QhAtvExtra.validations(required, maxLength, integer, minValue)
  },
  validationMessages: {
    atividade: QhAtvExtra.validationMessages()
  },
  data() {
    return {
      dialog: false,
      formTitle: "",
      btnTitle: "",
      loading: false,
      funcionarios: [],
      atividade: new QhAtvExtra(),
      headers: [
        { text: "", align: "center", sortable: false, value: "participante" },
        { text: "Nr Registro", align: "left", sortable: false, value: "numeroRegistro" },
        { text: "Nome", align: "left", sortable: false, value: "nome" },
        { text: "Função", align: "left", sortable: false, value: "funcao" }
      ]
    };
  },
  computed: {
    diaSemana() {
      if (!this.atividade.data) return "";
      const [dia, mes, ano] = String(this.atividade.data).split("/");
      if (!dia || !mes || !ano) return "";
      const d = new Date(`${ano}-${mes}-${dia}T00:00:00`);
      if (isNaN(d.getTime())) return "";
      return DIAS_SEMANA[d.getDay()];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    EventBus.$on("editaQhAtvExtra", async idAtividade => {
      const atv = await qhAtvExtraService.buscarPorId(idAtividade);
      if (!atv) return;
      this.formTitle = "Alterar Atividade Extra";
      this.btnTitle = "Alterar";
      this.atividade = new QhAtvExtra({
        id: atv.id,
        idQhPlano: this.plano.id,
        data: atv.data,
        descricao: atv.descricao,
        qtdeHora: atv.qtdeHora
      });
      await this.carregarFuncionarios(idAtividade);
      this.dialog = true;
    });
  },
  methods: {
    async abrirCadastro() {
      this.formTitle = "Incluir Atividade Extra";
      this.btnTitle = "Salvar";
      this.atividade = new QhAtvExtra();
      this.atividade.idQhPlano = this.plano.id;
      await this.carregarFuncionarios(null);
      this.dialog = true;
    },
    async carregarFuncionarios(idAtividade) {
      this.loading = true;
      this.funcionarios = await qhAtvExtraService.listarFuncionariosElegiveis(this.plano.id, idAtividade);
      this.loading = false;
    },
    onDataChange(novaData) {
      this.atividade.data = novaData;
    },
    confirmar() {
      this.$v.atividade.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const payload = {
        id: this.atividade.id,
        idQhPlano: this.plano.id,
        data: this.atividade.data,
        descricao: this.atividade.descricao,
        qtdeHora: this.atividade.qtdeHora,
        idsFuncionariosParticipantes: this.funcionarios
          .filter(f => f.participante)
          .map(f => f.idFuncionario)
      };
      qhAtvExtraService.salvar(payload).then(retorno => {
        if (retorno) {
          this.$emit("qhAtvExtraCadastrada", true);
          this.close();
        }
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
        this.atividade = new QhAtvExtra();
        this.funcionarios = [];
        EventBus.$emit("resetCustom");
      }, 300);
    }
  }
};
</script>
<style scoped>
.qh-atv-extra-funcs-scroll {
  max-height: 280px;
  overflow-y: auto;
}
</style>
